/* eslint-disable react-hooks/rules-of-hooks */
import { FC, useEffect, useMemo, useState } from 'react';
import { ISelectOption } from '../../../../../../../../../shared/components/form/fields/select.component';
import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../../shared/components/popup/popup.abstract';
import { TPopupDefaultActions } from '../../../../../../../../../shared/components/popup/services/popup.service';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { CopyCrossTable } from './copyCrossTable.form';

export class CopyCrossTablePopup extends Popup<ICopyCrossTablePopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const [options, setOptions] = useState<ISelectOption[]>([]);

      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 498 },
        }));
      }, []);

      const formMethods = useForm({
        mode: 'onBlur',
      });

      useEffect(() => {
        stream.state().subscribe(({ action, printListsOptions }) => {
          if (action === 'open') {
            setOptions(printListsOptions);
          }
          if (action === 'close') formMethods.reset();
        });
      }, []);

      return (
        <SWrapper fullWidth stream={stream} popupTitle={t('production.copy')}>
          <FormProvider {...formMethods}>
            <CopyCrossTable {...{ options, stream }} />
          </FormProvider>
        </SWrapper>
      );
    };
  }
}

interface ICopyCrossTablePopup {
  action: 'save' | TPopupDefaultActions;
  printListsOptions: ISelectOption[];
  idForCopy?: string;
}
